export const SET_WRAPPER_CLASS = 'SET.WRAPPER.CLASS';
export const SET_ACTIVE_STEP = 'SET.ACTIVE.STEP';
export const SET_INPUT_TERM = 'SET.INPUT.TERM';
export const SET_ACTIVE_TAB = 'SET.ACTIVE.TAB';
export const SET_SUGGESTIONS = 'SET.SUGGESTIONS';
export const SET_INITIAL_CATEGORIES = 'SET.INITIAL.CATEGORIES';
export const UPDATE_SELECTED_CATEGORY = 'UPDATE.SELECTED.CATEGORY';
export const SET_CATEGORIES_LEVEL = 'SET.CATEGORIES.LEVEL';
export const CLEAN_CATEGORIES = 'CLEAN.CATEGORIES';
export const SET_SEARCH = 'SET.SEARCH';
export const UNSET_SEARCH = 'UNSET.SEARCH';
export const SET_PRODUCTS_LOADING = 'SET.PRODUCTS.LOADING';
export const UNSET_PRODUCTS_LOADING = 'UNSET.PRODUCTS.LOADING';
export const SET_PRODUCTS = 'SET.PRODUCTS';
export const SET_USER_DETAILS = 'SET.USER.DETAILS';
export const SET_SELECTED_PRODUCT = 'SET.SELECTED.PRODUCT';
export const SET_PRODUCT_REG_GUID = 'SET.PRODUCT.REG.GUID';
export const SET_IS_CONFIRMATION = 'SET.IS.CONFIRMATION';
export const SET_HAS_MARKETING_CONSENT = 'SET.HAS.MARKETING.CONSENT';
